module.exports = __webpack_public_path__ + "img/like.8a0403a1.png";